import * as React from "react";
import { forwardRef } from "react";
const SvgIconsCheckSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h16v16H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M10.862 5.195a.667.667 0 0 1 .998.88l-.055.063-4.667 4.667a.667.667 0 0 1-.88.055l-.063-.055-2-2a.667.667 0 0 1 .88-.999l.063.056L6.667 9.39l4.195-4.195z", fill: "#1B3DF2", fillRule: "nonzero" })));
const ForwardRef = forwardRef(SvgIconsCheckSmall);
export default ForwardRef;
